import React from "react";
import { Button } from "reactstrap";
import PropTypes from "prop-types";
import starsWhite from "../../assets/img/stars_white.svg";

/**
 * PromoFooter - Footer buttons for create/edit promo modal
 * Contains Save as Draft / Cancel and Launch/Save buttons
 */
function PromoFooter({
  onCancel,
  onSubmit,
  isLaunchDisabled = true,
  isDraftDisabled = true,
  isMarket = false,
  isEdit = false,
  isDuplicate = false,
  isDraftPromo = false,
  isPilotHotel = false,
}) {
  const getButtonText = () => {
    if (isMarket) {
      return (
        <>
          <img
            src={starsWhite}
            alt=""
            width="16"
            height="16"
            style={{ marginRight: "8px" }}
          />
          <span>Launch a Promo</span>
        </>
      );
    }

    if (isDuplicate) {
      return <span>Create New Promo</span>;
    }

    if (isEdit) {
      return <span>Save Promo</span>;
    }

    return <span>Launch Promo</span>;
  };

  const showSaveAsDraft = !isMarket && (!isEdit || isDraftPromo || isDuplicate);

  return (
    <div className="create-promo-footer">
      {showSaveAsDraft ? (
        <Button
          color="secondary"
          onClick={() => onSubmit(true)}
          className="save-draft-btn"
          disabled={isDraftDisabled}
        >
          Save as Draft
        </Button>
      ) : (
        <Button color="secondary" onClick={onCancel} className="cancel-btn">
          Cancel
        </Button>
      )}

      <Button
        color="warning"
        onClick={() => onSubmit(false)}
        className={`launch-promo-btn ${isMarket ? "launch-smart-promo-btn" : ""}`}
        disabled={isLaunchDisabled}
      >
        {getButtonText()}
      </Button>
    </div>
  );
}

PromoFooter.propTypes = {
  onCancel: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  isLaunchDisabled: PropTypes.bool,
  isDraftDisabled: PropTypes.bool,
  isMarket: PropTypes.bool,
  isEdit: PropTypes.bool,
  isDuplicate: PropTypes.bool,
  isDraftPromo: PropTypes.bool,
  isPilotHotel: PropTypes.bool,
};

export default PromoFooter;
